// extracted by mini-css-extract-plugin
export var deleteIcon = "_qk-5";
export var deleteOption = "_qk-3";
export var divider = "_qk-2";
export var downloadIcon = "_qk-4";
export var drawer = "_qk-0";
export var drawerFooter = "_qk-6";
export var drawerOpen = "_qk-1";
export var highlighted = "_qk-7";
export var lighterHighlight = "_qk-8";